/**
 * Free Shipping Progress Component
 * Dynamisch aktualisiert den Versandkosten-Fortschritt bei Warenkorb-Änderungen
 */

class FreeShippingProgress extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold, 10) || 5000; // in cents
    this.progressMessage = this.dataset.progressMessage || 'Noch [amount] bis zum kostenlosen Versand!';
    this.successMessage = this.dataset.successMessage || 'Kostenloser Versand!';

    // Listen for cart updates
    document.addEventListener('cart:update', this.handleCartUpdate.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.handleCartUpdate.bind(this));
  }

  async handleCartUpdate() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.updateDisplay(cart.total_price);
    } catch (error) {
      console.error('Free shipping progress update failed:', error);
    }
  }

  updateDisplay(cartTotal) {
    const remaining = Math.max(0, this.threshold - cartTotal);
    const progressPercent = Math.min(100, (cartTotal / this.threshold) * 100);
    const achieved = remaining <= 0;

    // Update CSS variable for progress bar
    this.style.setProperty('--progress-percent', `${progressPercent}%`);

    // Update achieved state class
    if (achieved) {
      this.classList.add('free-shipping-progress--achieved');
    } else {
      this.classList.remove('free-shipping-progress--achieved');
    }

    // Update text
    const textElement = this.querySelector('.free-shipping-progress__text');
    if (textElement) {
      if (achieved) {
        textElement.textContent = this.successMessage;
      } else {
        const formattedAmount = this.formatMoney(remaining);
        textElement.textContent = this.progressMessage.replace('[amount]', formattedAmount);
      }
    }

    // Update icon
    const iconElement = this.querySelector('.free-shipping-progress__icon');
    if (iconElement) {
      if (achieved) {
        iconElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
          <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>`;
      } else {
        iconElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M1 3h15v13H1zM16 8h4l3 3v5h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/>
          <circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>`;
      }
    }
  }

  formatMoney(cents) {
    // Use Shopify's money format if available, otherwise fallback
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }

    // Fallback: Format as EUR
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return `${amount} €`;
  }
}

if (!customElements.get('free-shipping-progress')) {
  customElements.define('free-shipping-progress', FreeShippingProgress);
}
